<template>
    <div
        class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 sm:gap-x-6 sm:px-6 lg:px-8"
        :class="{'shadow-xs' : !layoutStore.isSubheaderOpen}">
        <button
            type="button"
            class="-m-2.5 p-2.5 text-gray-700 dark:text-gray-300 xl:hidden"
            @click="layoutStore.isSidebarOpen = true">
            <span class="sr-only">Open sidebar</span>
            <Icon
                name="bars"
                size="6"
                aria-hidden="true" />
        </button>

        <!-- Separator -->
        <div
            class="h-6 w-px bg-gray-200 xl:hidden"
            aria-hidden="true" />

        <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
            <div class="flex flex-1 items-center">
                <GlobalSearch v-if="useGlobalSearch" />
            </div>

            <div class="flex items-center gap-x-4 lg:gap-x-6">
                <NuxtLink
                    v-if="$can('create', 'orders')"
                    :to="localePath(orderWizardStore.currentStepRoute)"
                    class="-m-2.5 p-2 flex items-center gap-1 font-semibold rounded-md bg-primary-500/5 border border-primary-600 text-primary-600 dark:text-primary-300 hover:bg-primary-500/10">
                    <Icon
                        name="plus-circle"
                        size="6"
                        aria-hidden="true" />
                    <span class="text-sm hidden md:block">{{ $t('orders.newOrder') }}</span>
                </NuxtLink>
                <BaseSlotButton
                    :title="$t('notifications.title')"
                    type="button"
                    class="-m-2.5 p-2.5 text-gray-400 dark:text-gray-300 hover:text-gray-500 dark:hover:text-gray-200 relative"
                    @click="inboxOpen = !inboxOpen">
                    <span class="sr-only">View notifications</span>
                    <Icon
                        name="bell"
                        size="6"
                        aria-hidden="true" />
                    <span
                        v-if="notificationStore.unreadNotificationsCount > 0"
                        class="w-2 h-2 bg-danger-500 block absolute top-3 right-3 rounded-full" />
                    <NotificationInbox v-model="inboxOpen" />
                </BaseSlotButton>

                <!-- Separator -->
                <div
                    class="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
                    aria-hidden="true" />

                <UserMenu />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {useLayoutStore} from "@/store/layout"
import {useNotificationStore} from "@/store/notifications"
import {useOrderWizardStore} from "@/store/orderWizard"

const inboxOpen = ref(false)
const useGlobalSearch = ref(true)
const localePath = useLocalePath()

const layoutStore = useLayoutStore()
const notificationStore = useNotificationStore()
const orderWizardStore = useOrderWizardStore()
</script>
